/* FormResponsesPanel.js */

import React from "react";
import { Stack, Typography } from "@mui/material";
import { RenderContext } from "../../../Enums.js";
import { renderField, makeRenderRequest, getNestedPropertyValue } from "../../../fields/Fields.js";

import "./FormResponsesPanel.css";

export default function FormResponsesPanel({ fields, row, renderEnv }) {
  const filteredFields = Array.isArray(fields)
    ? fields.filter((field) => field.metaPanel !== true && field.datagridOnly !== true)
    : [];

  return (
    <div className="detail-panel-inner">
      <Stack direction="column" spacing={1} sx={{ height: 1 }}>
        {filteredFields.map((field, index) => (
          <DetailField key={index} field={field} row={row} renderEnv={renderEnv} />
        ))}
      </Stack>
    </div>
  );
}

/* ----------------------------- leaf ----------------------------- */

function DetailField({ field, row, renderEnv }) {
  const value = getNestedPropertyValue(row, field.dataSource);

  const req = makeRenderRequest({
    field,
    row,
    value,
    context: RenderContext.DETAIL_PANEL,
    theme: renderEnv?.theme,
    projectCode: renderEnv?.projectCode,
    locale: renderEnv?.locale,
    onCellUpdate: renderEnv?.handlers?.onCellUpdate,
    onFileUpdate: renderEnv?.handlers?.onFileUpdate,
    onReviewerChange: renderEnv?.handlers?.onReviewerChange,
  });

  return (
    <>
      <Typography variant="h6" className="detail-panel-label">
        {field.headerName}
      </Typography>
      {renderField(req)}
      <br />
    </>
  );
}
